// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 3582) return "static/chunks/3582-7ba274a699c81aef.js";
	if (chunkId === 277) return "static/chunks/277-f8733d919e190ef6.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 2631 ? "0c579ea0" : chunkId) + "." + {"2631":"6d137d471cb2bea8","5194":"38ce7c8d1b9c0279"}[chunkId] + ".js";
};